import { COMPANY_INFO } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';
import { useGuestQuoteClaimNoticeStore } from '../model/guest-quote-claim-notice.store';

/**
 * 견적 연결 결과 안내(결정 G10·G11). 앱 셸이 모든 화면 아래쪽에 한 번 둔다.
 * 고객 계정 아님·이미 다른 계정에 연결됨·찾을 수 없음·일시 실패를 알리고 고객센터(전화·메일·운영 시간)를 함께 보여 준다. 닫으면 사라지고, 인쇄에는 나오지 않는다.
 */
export const GuestQuoteClaimNotice = (): ReactElement | null => {
  const notice = useGuestQuoteClaimNoticeStore((state) => state.notice);
  const dismiss = useGuestQuoteClaimNoticeStore((state) => state.dismiss);

  if (notice === null) return null;

  return (
    <div
      role="alert"
      className="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-lg flex-col gap-3 border-t-2 border-destructive bg-background p-5 text-sm shadow-2xl break-keep sm:inset-x-auto sm:right-8 print:hidden"
    >
      <p className="text-base font-bold tracking-[-0.02em]">견적을 계정에 연결하지 못했어요</p>
      <p className="leading-relaxed">{notice.message}</p>
      <p className="leading-relaxed text-muted-foreground">
        고객센터{' '}
        <a
          href={`tel:${COMPANY_INFO.phone}`}
          className="font-semibold text-foreground tabular-nums underline underline-offset-4"
        >
          {COMPANY_INFO.phone}
        </a>{' '}
        ·{' '}
        <a href={`mailto:${COMPANY_INFO.email}`} className="underline underline-offset-4">
          {COMPANY_INFO.email}
        </a>
        <br />
        {COMPANY_INFO.consultationHours}
      </p>
      <div className="flex justify-end">
        <Button type="button" variant="outline" size="sm" onClick={dismiss}>
          닫기
        </Button>
      </div>
    </div>
  );
};
